import React, {Component} from "react";
import "./App.css";
import {PageAuth} from "./pages/PageAuth";
import {getToken} from "./utils/authToken";
import {MainRouting} from "./MainRouting";

export default class App extends Component {

    render() {
        return (
            getToken() ? <MainRouting/> : <PageAuth/>
        );
    }
}

